import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons';

function RegistrationForm() {

	let iFrameStyles = {
		background: 'transparent',
		border: '1px solid #ccc'
	}
	
	return (
		<section className="region reigstration" id="register">
			<h2><FontAwesomeIcon icon={faCalendarCheck} /> Register</h2>
			<div className="container">
				<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeELwYx4aw7dJGLvEy6C9LhsARsFiFUEf_daHrKYTjlJzdyWA/viewform?embedded=true" width="640" height="3427" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
			</div>
		</section>)
}
export default RegistrationForm;
